var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"select-seminar form-section"},[_c('h3',[_vm._v("Select seminar ")]),_c('v-select',{attrs:{"name":"seminar","options":_vm.seminare,"get-option-label":({title, date})=>`${title}`,"placeholder":"Select seminar"},on:{"input":_vm.updateSeminar}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }